import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import { HeaderBreadcrumb, SectionTitle } from '@components/ui';

import { Route } from '@/constants';
import { ProductDetails } from '@/modules/stocks/stock-product-details/product-details.component';
import { ProductStockBatchList } from '@/modules/stocks/stock-product-details/product-stock-batch-list.component';
import { StockOverview } from '@/modules/stocks/stock-product-details/stock-overview.component';
import { useStockDetails } from '@/modules/stocks/stock-product-details/stock-product-details.hook';

export const StockProductDetails = () => {
    const { isError, isLoading, error } = useStockDetails();
    return (
        <SectionContainer
            error={error}
            isError={isError}
            isLoading={isLoading}
            fallbackPath={Route.STOCK_ALL_PRODUCTS}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'space-y-2'}>
                    <HeaderBreadcrumb
                        items={[
                            { label: 'Stocks', href: Route.STOCK_ALL_PRODUCTS },
                            { label: 'Product Details' },
                        ]}
                    />
                    <SectionTitle>Product Details</SectionTitle>
                </div>

                <div className={'grid grid-cols-[1fr_3fr] gap-2'}>
                    <ProductDetails />
                    <div className={'space-y-2'}>
                        <StockOverview />
                        <ProductStockBatchList />
                    </div>
                </div>
            </Card>
        </SectionContainer>
    );
};

StockProductDetails.displayName = 'StockProductDetails';
